import { deserializeSuperjson, isSuperJSONResult } from '@lib/superjson';
import { createApi, fetchBaseQuery } from '@reduxjs/toolkit/query/react';
import { getToken } from '@ui/auth/get-token';
import { EnvConfig } from '@ui/config/env';
import { type ApiTagTypes } from '@ui/store/data';

export type { ApiTagTypes } from '@ui/store/data';

const rawBaseQuery = fetchBaseQuery({
  baseUrl: EnvConfig.getKey('API_BASEURL'),
  prepareHeaders: async (headers) => {
    const token = await getToken();

    if (token) {
      headers.set('Authorization', `Bearer ${token}`);
    }

    return headers;
  },
});

/**
 * Wraps the base query to deserialize both successful and error responses
 * using superjson. RTK Query's transformResponse only applies to successful
 * responses, so we need to handle error deserialization here.
 */
const baseQuery: typeof rawBaseQuery = async (args, api, extraOptions) => {
  const result = await rawBaseQuery(args, api, extraOptions);

  if (result.error?.data && isSuperJSONResult(result.error.data)) {
    result.error.data = deserializeSuperjson(result.error.data);
  }

  return result;
};

// eslint-disable-next-line @typescript-eslint/no-empty-object-type
export const api = createApi<typeof baseQuery, {}, 'api', ApiTagTypes>({
  reducerPath: 'api',
  baseQuery,
  endpoints: () => ({}),
  tagTypes: [
    'EditSnapQuoteBySiteCode',
    'EditSnapSiteConfig',
    'GetSnapSiteConfig',
  ],
});
